// External Components
import React from 'react';

//Components
import TextField from '@mui/material/TextField';

import i18n from '../../utils/i18n';
import { withTranslation } from 'react-i18next';

//REDUX
import ACTIONS, { fetchProviderData } from '../../redux/action';
import { connect } from 'react-redux';
import axios from '../../shared/axios/axiosProxy';

import telekom from '../../images/telekom.svg';
import mbh from '../../images/mbh.svg';
import perfekt from '../../images/perfekt.svg';
import headset from '../../images/icon-headset.svg';
import logo from '../../images/bookkeepie-logo.svg';
import warning from '../../images/icon-warning.svg';
import envelop from '../../images/icon-envelop.svg';

import classes from './providerEntry.module.scss';

const mapStateToProps = (state) => ({
	store: state,
});

const mapDispatchToProps = (dispatch) => ({
	addProviderInfo: (item) => dispatch(ACTIONS.addProviderInfo(item)),
	fetchProviderData: (JWT) => dispatch(fetchProviderData(JWT)),
});

class ForgotPassword extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			submitted: false,
			email: '',
			showError: false,
			messageFromServer: '',
			showNullError: false,
			errors: {
				email: '',
				password: '',
			},
		};
		this.recoverPassword = this.recoverPassword.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleBlur = this.handleBlur.bind(this);
	}
	recoverPassword = async (e) => {
		const { email } = this.state;
		if (email === '') {
			this.setState({
				showError: false,
				messageFromServer: '',
				showNullError: true,
			});
		} else {
			try {
				const response = await axios.post('/api/auth/recover', {
					email,
				});
				if (response.data.message === 'reset email sent') {
					this.setState({
						showError: false,
						messageFromServer: 'reset email sent',
						showNullError: false,
						submitted: true,
					});
				}
			} catch (error) {
				if (error.response.data === 'email not in db') {
					this.setState({
						showError: true,
					});
					this.setState({
						messageFromServer: i18n.t('general.notregistered'),
					});
					this.setState({
						showNullError: false,
					});
				}
			}
		}
	};
	handleChange(event) {
		event.preventDefault();
		this.setState({
			[event.target.name]: event.target.value,
		});
	}
	handleBlur(event) {
		const { name, value } = event.target;
		let errors = this.state.errors;
		const validEmailRegex = RegExp(
			//eslint-disable-next-line
			/^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
		);
		/* CHECK EACH FIELD INDIVIDUALLY FOR ERRORS */
		switch (event.target.name) {
			case 'email':
				errors.email = validEmailRegex.test(value)
					? ''
					: i18n.t('general.emailerror');
				break;

			default:
				break;
		}
		this.setState({ errors, [name]: value }, () => {});
	}
	render() {
		return (
			<>
				{this.state.submitted === false ? (
					<div className={classes.EntryContainer}>
						<div className={classes.EntryHeader}>
							<img src={logo} alt='bookkeepie' className={classes.EntryLogo} />
							<div className={classes.RegButton}>
								<span
									className={classes.MediumText}
									style={{ marginRight: '12px' }}>
									{i18n.t('general.doyouhaveanaccount')}{' '}
								</span>
								<a className={classes.noDecoration && classes.Blue14} href='/'>
									{i18n.t('general.iamloggingin')}
								</a>
							</div>
						</div>
						<div className={classes.EntryFields}>
							<div
								className={classes.EntryFieldsBox}
								style={{ minHeight: '368', height: 'fit-content' }}>
								<p className={classes.EntryTitle}>
									{i18n.t('general.forgotpassword')}
								</p>
								<p className={classes.MediumText}>
									{i18n.t('general.giveusyouremail')}
								</p>
								<div className={classes.providerLoginPaper}>
									<p
										style={{
											margintTop: '18px !important',
											marginBottom: '4px',
											fontSize: '14px',
											fontWeight: '500',
										}}>
										{`${i18n.t('general.emailaddress')} *`}
									</p>
									<TextField
										id='email'
										className={classes.EntryInput}
										type='email'
										name='email'
										value={this.state.email}
										//label={i18n.t('general.emailaddress')}
										onChange={(event) => {
											this.handleChange(event);
										}}
										onBlur={(event) => {
											this.handleBlur(event);
										}}
										error={this.state.emailError ? true : false}
										sx={{
											'& .MuiOutlinedInput-root': {
												borderRadius: '8px',
											},
										}}
									/>
								</div>

								{this.state.showError && (
									<p>
										<span className={classes.ErrorText}>
											{this.state.messageFromServer}
										</span>
									</p>
								)}
								<div>
									<button
										className={classes.EntryButton}
										onClick={() => this.recoverPassword()}>
										{i18n.t('general.requestnewpassword')}
									</button>
								</div>
								<div
									className={classes.EntrySecondaryButton}
									style={{ marginTop: '8px' }}>
									<a className={classes.noDecoration} href='/'>
										{i18n.t('general.backtologin')}
									</a>
								</div>
							</div>
							<div className={classes.EntryIssueContact}>
								<img src={headset} alt='headset' />
								<span
									className={classes.SmallText}
									style={{ textDecorationLine: 'none' }}>
									{i18n.t('general.isthereaproblem')}
								</span>
								<span
									className={classes.Blue12}
									style={{ textDecorationLine: 'none' }}>
									<a
										className={classes.noDecoration}
										href='https://ro.bookkeepie.com/contact-bookkeepie'
										target='_blank'
										rel='noreferrer'>
										{i18n.t('general.contactus')}
									</a>
								</span>
							</div>
							<div className={classes.EntryPartners}>
								<img src={telekom} alt='telekom partner' />
								<img src={mbh} alt='mbh partner' />
								<img src={perfekt} alt='perfekt partner' />
							</div>
						</div>
						<div className={classes.LoginBlueBox}></div>
					</div>
				) : (
					<div className={classes.EntryContainer}>
						<div className={classes.EntryHeader}>
							<img src={logo} alt='bookkeepie' className={classes.EntryLogo} />
							<div className={classes.RegButton}>
								<span className={classes.MediumText}>
									{i18n.t('general.doyouhaveanaccount')}{' '}
								</span>
								<a className={classes.noDecoration && classes.Blue14} href='/'>
									{i18n.t('general.iamloggingin')}
								</a>
							</div>
						</div>
						<div className={classes.EntryFields}>
							<div>
								<div
									className={classes.EntryFieldsBox}
									style={{ minHeight: '400px', height: 'fit-content' }}>
									<img src={envelop} alt='envelop' />
									<p
										className={classes.EntryTitle}
										style={{ marginTop: '24px' }}>
										{i18n.t('general.passwordresetlink')}
									</p>
									<span className={classes.MediumText}>
										{i18n.t('general.passwordresetconfirmation1')}
									</span>
									<span
										className={classes.Blue14}
										style={{ background: 'none' }}>
										{this.state.email}
									</span>
									<span className={classes.MediumText}>
										{' '}
										{i18n.t('general.passwordresetconfirmation2')}
									</span>
									<p
										className={classes.MediumText}
										style={{ marginTop: '16px' }}>
										{i18n.t('general.noemailrecieved')}
									</p>
									<div
										className={classes.EntrySecondaryButton}
										style={{ marginTop: '44px' }}>
										<a className={classes.noDecoration} href='/'>
											{i18n.t('general.backtologin')}
										</a>
									</div>
								</div>
							</div>
							<div className={classes.EntryIssueContact}>
								<img src={headset} alt='headset' />
								<span
									className={classes.SmallText}
									style={{ textDecorationLine: 'none' }}>
									{i18n.t('general.isthereaproblem')}
								</span>
								<span className={classes.Blue12}>
									<a
										href='https://ro.bookkeepie.com/contact-bookkeepie'
										target='_blank'
										rel='noreferrer'>
										{i18n.t('general.contactus')}
									</a>
								</span>
							</div>
							<div className={classes.EntryPartners}>
								<img src={telekom} alt='telekom partner' />
								<img src={mbh} alt='mbh partner' />
								<img src={perfekt} alt='perfekt partner' />
							</div>
						</div>
						<div className={classes.LoginBlueBox}></div>{' '}
					</div>
				)}
				{/* <PromiseLoadingIndicator /> */}
			</>
		);
	}
}

// ForgotPassword.propTypes = {
// 	classes: PropTypes.object.isRequired,
// };
export default withTranslation()(
	connect(mapStateToProps, mapDispatchToProps)(ForgotPassword)
);
